import { gql, useQuery } from "@apollo/client"
import { OffboardingStepsTermination } from "@oysterhr/schema"
import StepsLane from "./TabOffboardingProcess/StepsLane"

interface OffboardingProcessProps {
  engagementId: string
}

const OFFBOARDING_PROCESS_TAB_QUERY = gql`
  query OffboardingProcessTabQuery($engagementId: ID!) {
    engagement(engagementId: $engagementId) {
      termination {
        offboardingStepsTerminations {
          id
          status
          offboardingStep {
            osTitle
            order
            lane
            step
            duration
            skippable
          }
        }
        tmStepsTerminationHistories {
          changedFrom {
            osTitle
            lane
          }
          changedTo {
            osTitle
            lane
          }
          updatedAt
          whodunnit {
            name
          }
        }
        caStepsTerminationHistories {
          changedFrom {
            osTitle
            lane
          }
          changedTo {
            osTitle
            lane
          }
          updatedAt
          whodunnit {
            name
          }
        }
      }
    }
  }
`

export const TabOffboardingProcess = ({ engagementId }: OffboardingProcessProps) => {
  const { loading, data } = useQuery(OFFBOARDING_PROCESS_TAB_QUERY, {
    variables: { engagementId },
  })
  const sortSteps = (steps: OffboardingStepsTermination[]) => {
    return steps?.sort((stepA, stepB) => stepA.offboardingStep.order - stepB.offboardingStep.order)
  }

  const offboardingSteps = data?.engagement?.termination?.offboardingStepsTerminations
  const companyLaneSteps = sortSteps(
    offboardingSteps?.filter(
      (step: OffboardingStepsTermination) => step.offboardingStep.lane === "company",
    ),
  )
  const companyLaneHistories = data?.engagement?.termination?.caStepsTerminationHistories
  const tmLaneHistories = data?.engagement?.termination?.tmStepsTerminationHistories
  const tmLaneSteps = sortSteps(
    offboardingSteps?.filter(
      (step: OffboardingStepsTermination) => step.offboardingStep.lane === "tm",
    ),
  )
  return (
    <>
      {loading ? null : (
        <div className="my-8 flex justify-center">
          <StepsLane
            steps={companyLaneSteps}
            histories={companyLaneHistories}
            title="Company process"
          />
          <StepsLane steps={tmLaneSteps} histories={tmLaneHistories} title="Team member process" />
        </div>
      )}
    </>
  )
}
